export const removeSpecialCharacters = (str) => {
  str = str.replace(/["'"\,:';$%^&#^`~./]/g, "")
  return str;
}
